import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  HiHome,
  HiOutlineCloudUpload,
} from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";
import Route from "./Route";
import DriveStats from "./DriveStats";
import CreateFolderModal from "./CreateFolderModal";

export default function NavBar() {
  const navigate = useNavigate();
  const { user, menuOpen } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);



  return (
    <>
      <div className={`h-screen flex flex-col bg-[#f5f7fa] text-slate-700 transition-all duration-500 ease-in-out border-r border-slate-200 overflow-hidden ${menuOpen ? "w-72" : "w-20 items-center"}`}>
        {/* Workspace Brand & App Launcher */}
        <div className={`py-4 flex items-center shrink-0 ${menuOpen ? "px-5 gap-3" : "justify-center w-full"}`}>


          <img src={logo} alt="BVM Drive logo" className="w-fit h-12 object-cover shadow-sm" />

          {menuOpen && (
            <span className="text-[17px] font-bold text-slate-800 tracking-tight leading-none whitespace-nowrap">
              <span className="text-[#2d50e6] text-2xl">BVM</span> <span className="text-slate-800">Drive</span>
            </span>
          )}
        </div>

        {/* New Button */}
        <div className={`mb-8 mt-4 shrink-0 flex ${menuOpen ? "px-5" : "justify-center w-full"}`}>
          <button
            onClick={() => setIsModalOpen(true)}
            className={`flex items-center justify-center bg-[#2d50e6] hover:bg-blue-700 text-white rounded-full shadow-md transition-all duration-300 ${menuOpen
              ? "px-5 py-2.5 w-full max-w-[80%] gap-2"
              : "w-12 h-12 p-0 min-w-[3rem] min-h-[3rem] aspect-square"
              }`}
          >
            <FaPlus className={`shrink-0 ${menuOpen ? 'w-3.5 h-3.5' : 'w-5 h-5'}`} />
            {menuOpen && <span className="font-bold text-sm tracking-wide whitespace-nowrap">Add new</span>}
          </button>
        </div>

        {/* Navigation Items */}
        <div className={`flex-1 overflow-y-auto space-y-1 fancy-scrollbar w-full ${menuOpen ? "px-3" : "px-0 flex flex-col items-center"}`}>
          <Route
            name="Home"
            icon={<HiHome />}
            onClick={() => {
              navigate("home");
              window.dispatchEvent(new Event("resetToHomeFolders"));
            }}
            urlPath="home"
            isCollapsed={!menuOpen}
          />
          {/* <Route name="Home" icon={<HiHome />} onClick={() => alert("Home")} urlPath="home" isCollapsed={!menuOpen} /> */}
          {/* <Route name="My files" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/files" isCollapsed={!menuOpen} />
          <Route name="Shared" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/shared" isCollapsed={!menuOpen} />
          <Route name="Favorites" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/favorites" isCollapsed={!menuOpen} />
          <Route name="Recycle bin" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/recycle" isCollapsed={!menuOpen} />

          {menuOpen && <div className="text-xs font-bold text-slate-700 mt-6 mb-2 px-3">Browse files by</div>}
          <Route name="People" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/people" isCollapsed={!menuOpen} />
          <Route name="Meetings" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/meetings" isCollapsed={!menuOpen} />
          <Route name="Media" icon={<HiOutlineCloudUpload />} onClick={() => navigate("/my/home")} urlPath="/my/media" isCollapsed={!menuOpen} /> */}

          {/* {menuOpen && <div className="text-xs font-bold text-slate-700 mt-6 mb-2 px-3">Quick access</div>}
          <Route name="NotSynced" icon={<span className="w-5 h-5 rounded bg-purple-500 text-white flex items-center justify-center text-[10px]">T</span>} onClick={() => navigate("/my/home")} urlPath="/my/notsynced" isCollapsed={!menuOpen} />
          <Route name="T-Marketing B" icon={<span className="w-5 h-5 rounded bg-green-500 text-white flex items-center justify-center text-[10px]">TB</span>} onClick={() => navigate("/my/home")} urlPath="/my/tmarketing" isCollapsed={!menuOpen} /> */}
        </div>



        <CreateFolderModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            // You could trigger a refresh here if needed
            console.log("Folder created, refreshing...");
          }}
        />
      </div>
    </>
  );
}
